import { useEffect, useState } from "react";
import { MonitorFaturamentoService } from "../../../../services";
import { responseErros } from "../../../../utils";
import MonitorFatCard from "./monitor-fat-card.view";
import MonitorFatRankingBarra from "./monitor-fat-ranking-barra.view";

const monitorFaturamentoService = new MonitorFaturamentoService();

function MonitorFatRankingVendedoresServicos({ filtrosBody }) {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    buscarVendedoresServicos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtrosBody]);

  async function buscarVendedoresServicos() {
    setLoading(true);
    const result = await monitorFaturamentoService.rankingVendedoresServicos(
      filtrosBody,
    );
    if (!result.isAxiosError) {
      setRows(result.data || []);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const itens = rows.map((r) => ({
    key: r.prestadorId,
    label: r.nomePrestador,
    valor: r.valor,
  }));

  return (
    <MonitorFatCard
      titulo="Top 5 Vendedores de Serviços"
      icone="ph-medal"
      loading={loading}
      alturaSkeleton={160}
    >
      <MonitorFatRankingBarra itens={itens} corBarra="#00897b" />
    </MonitorFatCard>
  );
}

export default MonitorFatRankingVendedoresServicos;
